const API_DOMAIN = "https://exi-bo.hoyou.xyz/";
let EVENT_ID = null;

const winnerList = document.getElementById("winnerList");
const loadingScreen = document.getElementById("loadingScreen");

function sleep(ms) {
  return new Promise(r => setTimeout(r, ms));
}

function showLoading(show) {
  if (!loadingScreen) return;
  loadingScreen.style.display = show ? "flex" : "none";
}

// ✅ Check event status first (same as index)
async function checkEventStatus() {
  try {
    showLoading(true);
    const res = await fetch(`${API_DOMAIN}api/event/list`);
    const data = await res.json();
    await sleep(50);

    if (data.message === "success" && Array.isArray(data.data) && data.data.length > 0) {
      const event = data.data[0];
      EVENT_ID = event.id;
      if (event.status === 4) {
        // ✅ Event is open → load winners
        await loadWinners();
      } else {
        // 🚫 Not active → go to event closed page
        window.location.href = "eventClosed.html";
      }
    } else {
      window.location.href = "eventClosed.html";
    }
  } catch (err) {
    console.error("Error checking event status:", err);
    window.location.href = "eventClosed.html";
  } finally {
    showLoading(false);
  }
}

// ✅ Load winners from API
async function loadWinners() {

  winnerContainer.innerHTML = "";  // reset output

  const votes = [1, 2, 3];

  for (let v of votes) {
    try {
      showLoading(true);

      const res = await fetch(`${API_DOMAIN}api/internal/vote/participants`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ eventId: EVENT_ID, vote: v }),
      });

      const result = await res.json();
      await sleep(50);

      // ❌ Skip if empty winners
      if (result.message !== "success" || !result.data?.winners?.length) {
        continue; // ⬅ skip to next vote
      }

      // 👍 Now only create title + list when winners exist
      winnerContainer.innerHTML += `
        <h2 style='text-align:center; margin-bottom:10px'>Vote Player ${v}</h2>
        <ul id="winnerList${v}" class="player-list"></ul>
      `;

      const list = document.getElementById(`winnerList${v}`);
      const winners = result.data.winners;

      list.innerHTML = winners
        .map(w => `<li class="player-item">${w.ticketId}</li>`)
        .join("");

    } catch (err) {
      console.error(err);
    } finally {
      showLoading(false);
    }
  }

  // Optional: If all categories empty:
  if (winnerContainer.innerHTML.trim() === "") {
    winnerContainer.innerHTML = `
      <h2 style='text-align:center;'>No winners found yet</h2>
    `;
  }
}



// ✅ Init
document.addEventListener("DOMContentLoaded", async () => {
  showLoading(true);
  await sleep(50);
  await checkEventStatus();
});
